import styled from 'styled-components';

export const CompressorNodeWidgetContainer = styled.div<{
  $mapView: boolean;
  $textColor: string;
}>`
  position: relative;

  .data-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .border-header {
    padding-top: ${({ theme: { token } }) => token.paddingXS}px;
    padding-left: ${({ theme: { token } }) => token.padding}px;
    color: ${({ $textColor }) => $textColor};
  }

  .top-row {
    display: flex;
    height: 30%;
    align-items: center;
    margin-top: ${({ $mapView, $textColor, theme: { token } }) =>
      $mapView ? ($textColor ? 0 : token.margin) : token.marginSM}px;
    padding-left: ${({ $textColor, theme: { token } }) => ($textColor ? token.paddingLG : token.paddingMD)}px;

    .control-title-wrapper {
      display: flex;
      width: 70%;
      align-items: flex-start;

      .title {
        margin-left: ${({ theme: { token } }) => token.marginSM}px;
        text-transform: capitalize;
      }

      .model {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }
    }

    .connectivity-icon-wrapper {
      width: 30%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .middle-row {
    flex-grow: 0.8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .metrics-list {
    display: flex;
    gap: 5px;
    z-index: 2;
    justify-content: center;

    .metrics-list-item {
      .highlighted {
        color: ${({ theme: { token } }) => token.colorText};
      }

      .metrics-list-item-value {
        font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        color: ${({ theme: { token } }) => token.colorTextTertiary};

        &.highlighted {
          color: ${({ theme: { token } }) => token.colorText};
        }
      }

      .metrics-list-item-label {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }

  .toggles-wrapper {
    width: 100%;
    height: 52px;
    z-index: 3;
    position: absolute;
    display: flex;
    gap: 4px;
    justify-content: flex-end;
    bottom: 12px;
    left: -6px;
  }

  .package-care-wrapper {
    margin-bottom: ${({ $textColor }) => ($textColor ? 2 : 5.5)}%;
    margin-left: ${({ $textColor }) => ($textColor ? 4 : 2)}%;
  }
`;
